export const translations = {
  nome: {
    pt: "Nome",
    en: "Name",
    de: "Beschreibung",
    es: "Nombre",
  },
  descricao: {
    pt: "Descrição",
    en: "Description",
    de: "Beschreibung",
    es: "Descripción",
  },
};
